import React from 'react';
import ReactDOM from 'react-dom/client';
import './context/language/i18n'; // i18n 설정 파일 import

import { BrowserRouter } from 'react-router';

import { Provider } from 'react-redux';
import Store from './redux/store';

import './index.css';
import './theme/didimUserViewport.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={Store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
